export const getOnlyDirtyValues = (
  values: Record<string, any>,
  dirtyFields: Record<string, boolean>,
) => Object.fromEntries(Object.entries(values).filter(([key]) => dirtyFields[key]));
